import genericRule from '../../namespace/relation/doingCancel_namespace_relation';

export default {
    ...genericRule,
    excludedNamespaceRelations: [],
    namespace: 'application',
    relation: 'reset'
};
